import { useState } from "react";

import { Typography, TextField, InfoPanel } from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { getUserFromOibRequest } from "../../api/nisooApi";
import { ButtonWithValidation } from "../../components/ButtonWithValidation";
import StaticField from "../../components/StaticField";
import UploadButton from "../../components/UploadButton";
import { DocumentType } from "../../models/Document";
import { ProgramRequestTeacher } from "../../models/ProgramRequest";
import styles from "./ProgramRequestMzo.module.scss";


type ProgramRequestTeacherMzoProps = {
    name: string;
    programRequestTeachers: ProgramRequestTeacher[],
    programRequestTeacherCorrection: ProgramRequestTeacher[],
    onChange: (e: any) => void;
    getErrorForPath: (path: string) => string | undefined;
}


export default function ProgramRequestTeacherMzo({name, programRequestTeachers, programRequestTeacherCorrection, onChange, getErrorForPath}: ProgramRequestTeacherMzoProps) : JSX.Element{
    const { t } = useTranslation();
    const [userNotFound, setUserNotFound] = useState<boolean[]>([] as boolean[]);
    const [userFound, setUserFound] = useState<boolean[]>([] as boolean[]);

    const handleOibChange = (event: any, index: number) => {
        var teacherCorrectionList = programRequestTeacherCorrection.slice();
        teacherCorrectionList[index].oib = event.target.value;
        teacherCorrectionList[index].oibChecked = false;
        onChange({
            ...event,
            target: {
                ...event.target,
                name: name,
                value: teacherCorrectionList
            }
        });
    };

    const handleFirstNameChange = (event: any, index: number) => {       
        var teacherCorrectionList = programRequestTeacherCorrection.slice();
        teacherCorrectionList[index].firstName = event.target.value;
        teacherCorrectionList[index].oibChecked = false;
        onChange({
            ...event, 
            target: {
                ...event.target,
                name: name,
                value: teacherCorrectionList
            }
        });
    };

    const handleLastNameChange = (event: any, index: number) => {
        var teacherCorrectionList = programRequestTeacherCorrection.slice();
        teacherCorrectionList[index].lastName = event.target.value;
        teacherCorrectionList[index].oibChecked = false;
        onChange({
            ...event,
            target: {
                ...event.target,
                name: name,
                value: teacherCorrectionList
            }
        });
    };

    const handleClassEnsambleChange = (event: any, ensambleIndex: number, teacherIndex: number) => {
        var ensambleCorrectionList = programRequestTeacherCorrection[teacherIndex].programRequestClassEnsambles.slice();
        ensambleCorrectionList[ensambleIndex].ensamble = event.target.value;
        var teacherCorrectionList = programRequestTeacherCorrection.slice();
        teacherCorrectionList[teacherIndex].programRequestClassEnsambles = ensambleCorrectionList;
        onChange({
            ...event,
            target: {
                ...event.target,
                name: name,
                value: teacherCorrectionList
            }
        });
    };

    const onCheckUserData = async(event: any, teacherIndex: number) => {
        
        if(programRequestTeacherCorrection[teacherIndex].oib.trim() != "" && programRequestTeacherCorrection[teacherIndex].firstName.trim() != "" && programRequestTeacherCorrection[teacherIndex].lastName.trim() != ""){

            var userInfo = await getUserFromOibRequest(programRequestTeacherCorrection[teacherIndex].oib,  programRequestTeacherCorrection[teacherIndex].firstName,programRequestTeacherCorrection[teacherIndex].lastName);

            if(userInfo && userInfo.firstName && userInfo.lastName){
                var userFoundList = userFound.slice();
                userFoundList[teacherIndex] = true;
                var userNotFoundList = userNotFound.slice();
                userNotFoundList[teacherIndex] = false;

                setUserFound(userFoundList);
                setUserNotFound(userNotFoundList);

                var teacherCorrectionList = programRequestTeacherCorrection.slice();
                teacherCorrectionList[teacherIndex].firstName = userInfo.firstName;
                teacherCorrectionList[teacherIndex].lastName = userInfo.lastName;

                onChange({
                    ...event,
                    target: {
                        ...event.target,
                        name: name,
                        value: teacherCorrectionList
                    }
                });                
            }

            return;
        }
        var userFoundList = userFound.slice();
            userFoundList[teacherIndex] = false;
            var userNotFoundList = userNotFound.slice();
            userNotFoundList[teacherIndex] = true;

            setUserFound(userFoundList);
            setUserNotFound(userNotFoundList);
    };

    return (
        <>
            <Row>
                <Col md={12} className={styles.rowTitleSpacing}>
                    <Typography variant="smallHeading" component="h3">
                        {t("request.teacherTitle")}                        
                    </Typography>
                </Col>
            </Row>
            {programRequestTeachers.map((teacher, teacherIndex) => {

                return(                    
                    <div className={styles.modulePanel}>
                        {userNotFound && userNotFound[teacherIndex] && 
                            <Row>
                                <Col md={12}>
                                    <InfoPanel
                                        message={t("userRole.userNotFound", {oib: programRequestTeacherCorrection[teacherIndex].oib.toString().padStart(11, "0")})}
                                        color="warning"
                                        fullWidth
                                    />                            
                                </Col>
                          </Row>
                        }
                        {userFound && userFound[teacherIndex] &&
                            <Row>
                                <Col md={12}>
                                    <InfoPanel
                                        message={t("userRole.userFound")}
                                        color="success"
                                        fullWidth
                                    />
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col md={3}>  
                                <StaticField
                                    label={t("request.teacherOIB")}
                                    value={teacher.oib}
                                />
                            </Col>
                            <Col md={3}>  
                                <StaticField
                                    label={t("request.teacherFirstName")}
                                    value={teacher.firstName}
                                />
                            </Col> 
                            <Col md={3}>
                                <StaticField
                                    label={t("request.teacherLastName")}
                                    value={teacher.lastName}
                                />
                            </Col>                           
                        </Row>
                        <Row className={styles.learningSetEditRow}>
                            <Col md={3}>
                                <TextField                                                                       
                                    value={programRequestTeacherCorrection[teacherIndex].oib}                                    
                                    onChange={(e) => handleOibChange(e, teacherIndex)}
                                    errorText={getErrorForPath(`${name}${teacherIndex}.oib`)}                                    
                                />
                            </Col>
                            <Col md={3}>
                                <TextField
                                    value={programRequestTeacherCorrection[teacherIndex].firstName}                                    
                                    onChange={(e) => handleFirstNameChange(e, teacherIndex)}
                                    errorText={getErrorForPath(`${name}${teacherIndex}.firstName`)}
                                />
                            </Col>
                            <Col md={3}>
                                <TextField
                                    value={programRequestTeacherCorrection[teacherIndex].lastName}
                                    onChange={(e) => handleLastNameChange(e, teacherIndex)}
                                    errorText={getErrorForPath(`${name}${teacherIndex}.lastName`)}
                                />
                            </Col>
                            <Col md={3} className={styles.provjeraPodatakaContainer} >                                
                                <ButtonWithValidation
                                    outline
                                    className={styles.checkDataButton}
                                    onClick={(e) => onCheckUserData(e, teacherIndex)}
                                    errorText={getErrorForPath(`${name}${teacherIndex}.oibChecked`)}
                                >
                                    {t("request.teacherCheck")}
                                </ButtonWithValidation>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3} className={styles.hideUploadButton}>
                                {teacher.diplomaDocument && 
                                    <UploadButton
                                        label={t("request.teacherDiplomaLabel")}
                                        value={teacher.diplomaDocument}
                                        disabled={true}
                                        documentType={DocumentType.TeacherDiploma}
                                    /> || 
                                    <StaticField
                                        label={t("request.teacherDiplomaLabel")}
                                        value={teacher.diplomaDocument?.fileName}
                                        className={styles.changedFieldModule}
                                    />
                                }
                            </Col>
                            <Col md={3} className={styles.hideUploadButton}>
                                {teacher.statement && 
                                    <UploadButton
                                        label={t("request.teacherStatementLabel")}
                                        value={teacher.statement}
                                        disabled={true}
                                        documentType={DocumentType.TeacherStatement}
                                    /> || 
                                    <StaticField
                                        label={t("request.teacherStatementLabel")}
                                        value={teacher.statement?.fileName}
                                        className={styles.changedFieldModule}
                                    />
                                }
                            </Col>
                            <Col md={3} className={styles.hideUploadButton}>
                                {teacher.additionalDocumentation && 
                                    <UploadButton
                                        label={t("request.teacherDocumentationLabel")} 
                                        value={teacher.additionalDocumentation}
                                        disabled={true}
                                        documentType={DocumentType.TeacherAdditional}
                                    /> || 
                                    <StaticField
                                        label={t("request.teacherDocumentationLabel")}
                                        value={teacher.additionalDocumentation?.fileName}
                                        className={styles.changedFieldModule}
                                    />
                                }
                            </Col>
                        </Row>          
                        {teacher.programRequestClassEnsambles && teacher.programRequestClassEnsambles.map((ensamble, ensambleIndex) => (
                            <>
                            <Row>
                                <Col md={12}>
                                    <StaticField
                                        label={t("request.classEnsamble")}
                                        value={ensamble.ensamble}
                                    />
                                </Col>
                            </Row>
                            <Row className={styles.learningSetEditRow}>
                                <Col md={12}>
                                    <TextField
                                        className={"w-100"}
                                        value={programRequestTeacherCorrection[teacherIndex].programRequestClassEnsambles[ensambleIndex].ensamble}
                                        maxLength={500}
                                        onChange={(e) => handleClassEnsambleChange(e, ensambleIndex, teacherIndex)}
                                        errorText={getErrorForPath(`${name}${teacherIndex}.programRequestClassEnsambles${ensambleIndex}.ensamble`)}
                                    />
                                </Col>
                            </Row>
                            </>
                        ))}

                    </div>
                )

            })}
        </>
    );
}